module.exports = __webpack_public_path__ + "resources/img/img_tcc_advantage2.06e197a7d3caca323b2c2fe754483eac.jpg";